import { render, staticRenderFns } from "./PaymentReceived.vue?vue&type=template&id=4fd99bfe&scoped=true&"
import script from "./PaymentReceived.vue?vue&type=script&lang=js&"
export * from "./PaymentReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd99bfe",
  null
  
)

export default component.exports